import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';
import { FormFieldComponent } from '../form-field/form-field.component';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-checkbox-field',
  templateUrl: 'checkbox-field.component.html',
  styleUrls: ['checkbox-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxFieldComponent
  extends FormFieldComponent
  implements OnChanges, OnDestroy {
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() fieldId: string;
  @Input() e2eId: string;
  @Input() icon: IIcon;
  @Input() description: string;
  @Input() fieldControl: AbstractControl;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingIdentifier: string;
  @Input() trackingAdditionalProperties: any;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onClick: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() onClickIcon: EventEmitter<void> = new EventEmitter<void>();

  private _fieldSub: Subscription;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService,
    private _trackingDispatcher: TrackingDispatcher,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {
    super(changeDetectorRef, translateService);
  }

  ngOnChanges(changes) {
    const trackingObject = changes.trackingObject
      ? changes.trackingObject.currentValue
      : this.trackingObject;
    const trackingIdentifier = changes.trackingIdentifier
      ? changes.trackingIdentifier.currentValue
      : this.trackingIdentifier;
    const trackingScreenName = changes.trackingScreenName
      ? changes.trackingScreenName.currentValue
      : this.trackingScreenName;

    if (
      this.fieldControl &&
      trackingObject &&
      trackingIdentifier &&
      trackingScreenName
    ) {
      this._fieldSub && this._fieldSub.unsubscribe();

      this._fieldSub = this.fieldControl.valueChanges
        .pipe(distinctUntilChanged(), takeUntil(this.destroyed))
        .subscribe((value) => {
          const trackingAction = value
            ? this._trackingActionBuilder.buildCheckboxChecked(
                trackingIdentifier,
                trackingScreenName
              )
            : this._trackingActionBuilder.buildCheckboxUnchecked(
                trackingIdentifier,
                trackingScreenName
              );

          this._trackingDispatcher.trackEvent(
            trackingObject,
            trackingAction,
            this.trackingAdditionalProperties
          );
        });
    }
  }

  ngOnDestroy() {
    this._fieldSub && this._fieldSub.unsubscribe();

    super.ngOnDestroy();
  }
}
